import MerchantFacade from "../../../views/MerchantFacade";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const MerchantFacadeRoutes = [
  {
    menuName: MenuNames.MERCHANT_FACADE_PIC,
    path: "/merchant-facade",
    component: MerchantFacade,
    exact: true,
  },
];

export default MerchantFacadeRoutes;
